import { ArrowRight, Phone, ShieldCheck, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyForAFairOffer() {
  return <section data-section-id="164871" id="initiate-investigation" className="dark bg-background text-foreground py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center">
        <h2 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter mb-6 text-foreground">
          Ready to Reclaim Your Assets?
        </h2>
        
        <p className="text-muted-foreground text-lg md:text-xl mb-12 max-w-2xl font-sans">
          Join our global network of experts in tracing and recovering lost digital assets through advanced forensics.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-16 w-full sm:w-auto">
          <Button size="lg" className="w-full sm:w-auto text-base h-14 px-8 shadow-xl shadow-primary/30 animate-pulse bg-primary text-primary-foreground hover:bg-primary/90" asChild>
            <Link to="/ContactPage">
              Open a Case
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          
          <Button size="lg" variant="outline" className="w-full sm:w-auto text-base h-14 px-8 border-primary/30 text-foreground hover:bg-accent hover:text-accent-foreground backdrop-blur-sm">
            <Phone className="mr-2 size-5 text-primary" />
            Call: +1 343 882 4483
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-8 md:gap-16 items-center pt-10 border-t border-border/30 w-full max-w-3xl">
          <div className="flex items-center gap-3 text-sm md:text-base text-muted-foreground font-mono">
            <div className="flex items-center justify-center size-10 rounded-full bg-primary/10 border border-primary/20">
              <Star className="size-5 text-primary fill-primary/20" />
            </div>
            Verified Forensic Unit
          </div>
          <div className="flex items-center gap-3 text-[12px] md:text-[12px] text-muted-foreground/70 font-sans max-w-[280px] text-left">
            <div className="flex items-center justify-center size-10 rounded-full bg-primary/10 border border-primary/20 shrink-0">
              <ShieldCheck className="size-5 text-primary" />
            </div>
            Recovery is subject to investigation findings and is not guaranteed.
          </div>
        </div>
      </div>
    </section>;
}